<template>
  <!-- 保全信息 -->
  <div class="list">
    <span class="tips">提示：批改清单仅需上传该批单存在批改变动的人员清单</span>
    <div>
      <Button type="warning" class="add-btn" @click="$refs.preservationRef.open({}, policyNo)">新增保全</Button>
    </div>

    <div class="table-box">
      <loading :isShow="loading" />
      <Table :columns="preservationColumns" :data="preservationTableData">
        <template slot-scope="{ row }" slot="correctionList">
          <div>
            <span class="table-btn" @click="seeList(row)" v-if="row.insureCounts">查看清单</span>
            <span class="table-btn" @click="uploadList(row)" v-if="!row.insureCounts">上传清单</span>
            <span class="table-btn" @click="uploadList(row)" v-if="row.insureCounts">重新上传</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="$refs.preservationRef.open(row, policyNo)">编辑</span>
            <span class="table-btn" @click="del(row)">删除</span>
          </div>
        </template>
      </Table>
    </div>
    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />

    <!-- 新增保全 -->
    <preservationForm ref="preservationRef" @success="getPreservationList" :endTime="endTime"></preservationForm>

    <!-- 查看清单 -->
    <preservationList ref="preservationListRef"></preservationList>

    <!-- 批量导入 -->
    <batchImport ref="batchImport" :type="3" @upload-success="getPreservationList"></batchImport>
  </div>
</template>

<script>
let typeMap = {
  1: '增保',
  2: '替保',
  3: '减保'
};

import preservationForm from '../components/preservationForm';
import preservationList from '../components/preservationList';
import batchImport from '../components/batchImport';
import { number_format } from '@/api/filter';

export default {
  name: 'preservationInfo',
  props: ['policyNo', 'endTime', 'editFlag'],
  components: {
    preservationForm,
    preservationList,
    batchImport
  },
  data() {
    return {
      loading: false,
      preservationTableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      preservationColumns: [
        {
          title: '批单号',
          key: 'billNo',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '变更类型',
          key: 'type',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            if (params.row.type) {
              return <span> {typeMap[params.row.type]}</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '变更内容',
          key: 'createTime',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let type = params.row.type; // 1-增  2-替 3-减
            if(!type){
              return <span>-</span>;
            }
            if (type == 1) {
              return <span>{ params.row.addCounts ? '加' + params.row.addCounts + '人' : '-' }</span>;
            } else if (type == 2) {
              return (
                <span>
                  加{params.row.addCounts}人，减{params.row.delCounts}人
                </span>
              );
            } else {
              return <span>{ params.row.delCounts ? '减' + params.row.delCounts + '人' : '-' }</span>;
            }
          }
        },
        {
          title: '变更保费',
          key: 'fee',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.fee, 2)}</span>;
          }
        },
        {
          title: '批单生效日期',
          key: 'startTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let startTime = params.row.startTime.substring(0, 10);
            return <span>{startTime}</span>;
          }
        },
        {
          title: '承保日期',
          key: 'issueTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let issueTime = params.row.issueTime.substring(0, 10);
            return <span>{issueTime}</span>;
          }
        },
        {
          title: '投保日期',
          key: 'insureTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let insureTime = params.row.insureTime.substring(0, 10);
            return <span>{insureTime}</span>;
          }
        },
        {
          title: '支付日期',
          key: 'payTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let payTime = params.row.payTime.substring(0, 10);
            return <span>{payTime}</span>;
          }
        },
        {
          title: '批改清单',
          slot: 'correctionList',
          minWidth: 220,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '180',
          fixed: 'right'
        }
      ]
    };
  },
  methods: {
    setData() {
      this.getPreservationList();
    },

    // 获取保全信息列表
    getPreservationList() {
      this.loading = true;
      this.$http({
        url: '/buz/endorsement/read/list',
        type: 'POST',
        data: {
          pageSize: this.pageSize,
          pageNo: this.pageNum,
          policyNo: this.policyNo
        }
      }).then(res => {
        this.total = res.total;
        this.preservationTableData = res.data;
        this.loading = false;
      });
    },

    // 查看清单
    seeList(row) {
      this.$refs.preservationListRef.open(row.policyNo, row.id);
    },

    // 上传清单
    uploadList(row) {
      this.$refs.batchImport.open(row.policyNo, row);
    },

    del(row) {
      this.$Modal.confirm({
        title: '确定删除吗？',
        onOk: () => {
          this.$http({
            url: `/buz/grouppolicy/enter/endorsement/delete`,
            type: 'GET',
            data: {
              id: row.id
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.getPreservationList();
          });
        },
        onCancel: () => {}
      });
    },

    //分页切换页码
    pageChange(pageNum) {
      this.pageNum = pageNum;
      this.getPreservationList();
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  margin-bottom: 20px;
  .tips {
    color: #515a6e;
    display: block;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .title {
    color: #3c464f;
    font-size: 16px;
    font-weight: bold;
  }
  .add-btn {
    margin: 0px 0 20px 0;
  }
}
</style>
